import React from "react";

const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Forex Spreads</h1>
        <p>
          We offer some of the tightest spreads globally, averaging 0.1 pips on EUR/USD. Combined with low-latency hardware, our platform is ideal for active day traders and Expert Advisors. See minimum and average rates in the table below.
        </p>
      </div>
    </div>
  );
};

export default TopicOne;